import React from "react";
import DatePicker from "react-datepicker";
import StyledDialog from "../StyledDialog";

// Step 1 of the two-step date change: pick a new date/time. "Değiştir" moves to
// the confirmation dialog (handled by the container) — never updates directly.
const DateChangeModal = ({ open, onClose, startDate, onDateChange, onNext }) => {
    return (
        <StyledDialog open={open} onClose={onClose}>
            <div className="olp-theme olp-modal olp-modal--narrow">
                <h2 className="olp-modal-title">Ders Tarihini Değiştir</h2>
                <div className="olp-datepicker">
                    <DatePicker
                        selected={startDate}
                        onChange={onDateChange}
                        timeInputLabel="Time:"
                        dateFormat="MM/dd/yyyy h:mm aa"
                        showTimeInput
                        inline
                    />
                </div>
                <div className="olp-modal-footer">
                    <button type="button" className="olp-btn" onClick={onClose}>
                        Vazgeç
                    </button>
                    <button type="button" className="olp-btn olp-btn--primary" onClick={onNext}>
                        Değiştir
                    </button>
                </div>
            </div>
        </StyledDialog>
    );
};

export default DateChangeModal;
